import React from 'react';
import { styled } from '@mui/material/styles';
import { renderHTML } from '@agility/nextjs';
import { useRouter } from 'next/router';

const Container = styled('div')(({ $contentAlign, $videoExists }) => ({
  display: 'flex',
  flexFlow: 'row',
  justifyContent: 'center',
  alignItems: 'flex-start',
  position: 'relative',
  '@media screen and (min-width: 900px)': {
    flexDirection: $contentAlign === 'right' && $videoExists ? 'row-reverse' : 'row',
  },
}));

const ContentContainer = styled('div')(({ $videoExists }) => ({
  flexGrow: 1,
  flexShrink: 0,
  flex: 1,
  verticalAlign: 'top',
  '@media screen and (min-width: 900px)': {
    margin: '5px 50px',
    padding: '2% 5%',
    maxWidth: $videoExists ? '50%' : '90%',
  },
  '@media screen and (min-width: 1200px)': {
    margin: '5px 30px',
    padding: '4% 8%',
    maxWidth: $videoExists ? '50%' : '90%',
  },
}));

const VideoContainer = styled('div')(({ $videoExists }) => ({
  flexGrow: 0,
  flexShrink: 1,
  minWidth: '50%',
  margin: 0,
  '@media screen and (max-width: 899px)': {
    display: 'none',
  },
  '@media screen and (min-width: 900px)': {
    display: $videoExists ? 'block' : 'none',
    maxWidth: $videoExists ? '50%' : '0',
    maxHeight: $videoExists ? '95%' : '0',
  },
}));

const Title = styled('div')(({ $titleColor }) => ({
  fontWeight: 600,
  margin: '25px 5px',
  '@media screen and (max-width: 899px)': {
    color: $titleColor,
    fontSize: '1.75rem',
    lineHeight: '1.95rem',
    padding: '0 25px',
  },
  '@media screen and (min-width: 900px)': {
    color: $titleColor,
    fontSize: '2.25rem',
    lineHeight: '2.5rem',
  },
}));

const _PostContent = styled('div')(({ theme }) => ({
  color: theme.palette.primary.main,
  backgroundColor: 'transparent',
  margin: '5px 0 10px 0',
  fontSize: '0.90rem',
  fontWeight: 400,
}));

const SubTitle = styled('div')`
  margin: 0 5px;
  @media screen and (max-width: 899px) {
    display: none;
  }
`;

const SummaryDescription = styled('div')(({ $descriptionColor }) => ({
  marginTop: 10,
  fontWeight: 300,
  margin: '30px 5px',
  '@media screen and (max-width: 899px)': {
    color: $descriptionColor,
    fontSize: '1rem',
    lineHeight: '1.3rem',
    padding: '0 25px',
  },
  '@media screen and (min-width: 900px)': {
    color: $descriptionColor,
    fontSize: '1rem',
    lineHeight: '1.3rem',
  },
}));

const _ButtonContainer = styled('div')`
  margin: 40px 5px;
  @media screen and (max-width: 899px) {
    padding: 0 25px;
  }
`;

const SummaryWithBackgroundAndVideo = ({ module }) => {
  const { fields } = module;

  const router = useRouter();

  const _callAction = (event) => {
    event.preventDefault();
    router.push(fields.actionButtonUrl.href);
  };

  const videoExists = fields.videoScript && fields.videoScript.length > 0;

  return (
    <React.Fragment>
      <Container
        $contentAlign={fields.contentAlign}
        $videoExists={videoExists}
        style={{
          backgroundImage: `url(${fields.backgroundImage.url})`,
        }}
      >
        <ContentContainer $videoExists={videoExists}>
          <Title $titleColor={fields.titleColor}>{fields.title}</Title>
          <SubTitle className='prose max-w-full mx-auto' dangerouslySetInnerHTML={renderHTML(fields.subTitle)}></SubTitle>
          <SummaryDescription $descriptionColor={fields.descriptionColor}>{fields.description}</SummaryDescription>
        </ContentContainer>
        <VideoContainer $videoExists={videoExists}>
          <div className='prose max-w-full mx-auto' dangerouslySetInnerHTML={renderHTML(fields.videoScript)} />
        </VideoContainer>
      </Container>
    </React.Fragment>
  );
};
export default SummaryWithBackgroundAndVideo;